export class Avaliacao {
	id: number;
	descricao: string;
	dataFim: Date;
	dataInicio: Date;
	nome: string;
	usuarioAlteracao: number;
}